import { render, staticRenderFns } from "./ChatModal.vue?vue&type=template&id=225c3fe4&scoped=true"
import script from "./ChatModal.vue?vue&type=script&lang=js"
export * from "./ChatModal.vue?vue&type=script&lang=js"
import style0 from "./ChatModal.vue?vue&type=style&index=0&id=225c3fe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225c3fe4",
  null
  
)

export default component.exports